import { combineReducers } from 'redux';
import { GET_ROSTER, GET_SESSION } from './bridge-methods';
import { createBaseAsyncReducer } from '../redux-util/async-helpers';
import groups from './groups/reducer';
import adoptions from './adoptions/reducer';
import assets from './assets/reducer';
import users from './users/reducer';
import assetGroups from './assetGroups/reducer';
import taxonomy from './taxonomy/reducer';
import errors from './errors/reducer';

export default combineReducers({
  [GET_SESSION]: createBaseAsyncReducer(GET_SESSION),
  [GET_ROSTER]: createBaseAsyncReducer(GET_ROSTER),
  assetGroups,
  groups,
  adoptions,
  assets,
  users,
  taxonomy,
  errors,
});
